export const AllOWED_FILE_EXTENSIONS: string[] = ['pdf', 'png', 'jpg'];
